import BackgroundColor from './constants/BackgroundColor';
import BackButton from './Nav/BackButton';
import NextButton from './Nav/NextButton';
import SkipButton from './Nav/SkipButton';
import PageHeader from './PageHeader/PageHeader';
import SplitLayout, { RightNav, SplitLayoutBase } from './SplitLayout';

export {
  SplitLayoutBase,
  PageHeader,
  BackgroundColor,
  RightNav,
  NextButton,
  BackButton,
  SkipButton,
};
export default SplitLayout;
